import styled from "styled-components";
import { Button } from "../../ui/Button";

export const Wrapper = styled.footer`
  position: relative;
  margin-top: auto;
  background: ${({ theme }) =>
    `linear-gradient(180deg, ${theme.colors.background.app} 0%, ${theme.colors.background.surfaceAlt} 42%, ${theme.colors.background.surface} 100%)`};
  border-top: 1px solid ${({ theme }) => theme.colors.border.subtle};
  color: ${({ theme }) => theme.colors.text.primary};
  padding: ${({ theme }) =>
    `${theme.spacing(5)} ${theme.spacing(2.5)} ${theme.spacing(4)}`};
  text-align: center;
  overflow: hidden;

  @media (max-width: 768px) {
    padding-bottom: ${({ theme }) => theme.spacing(4)};
  }
`;

export const Content = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(2)};
  align-items: center;
  justify-content: center;
`;

export const Copy = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.body};
  color: ${({ theme }) => theme.colors.text.primary};
  font-weight: 500;
`;

export const SocialList = styled.ul`
  list-style: none;
  display: flex;
  gap: ${({ theme }) => theme.spacing(1.5)};
  margin: 0;
  padding: 0;
`;

export const SocialItem = styled.li`
  display: inline-flex;
`;

export const SocialLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${({ theme }) => theme.spacing(5)};
  height: ${({ theme }) => theme.spacing(5)};
  border-radius: ${({ theme }) => `${theme.radius.sm}px`};
  background: ${({ theme }) => theme.colors.background.surfaceAlt};
  border: 1px solid ${({ theme }) => theme.colors.border.subtle};
  color: ${({ theme }) => theme.colors.accent.primary};
  transition: color ${({ theme }) => theme.motion.fast} ease,
    background ${({ theme }) => theme.motion.fast} ease,
    transform ${({ theme }) => theme.motion.fast} ease,
    border-color ${({ theme }) => theme.motion.fast} ease;

  svg {
    display: block;
  }

  &:hover,
  &:focus-visible {
    color: ${({ theme }) => theme.colors.text.inverse};
    background: ${({ theme }) => theme.colors.accent.primary};
    border-color: ${({ theme }) => theme.colors.accent.primary};
    transform: translateY(-2px);
    outline: none;
  }
`;

export const BackToTopButton = styled(Button).attrs({
  variant: "primary",
  size: "sm",
})`
  position: relative;
  z-index: 1;
  min-width: ${({ theme }) => theme.spacing(15)};
  justify-content: center;
  font-weight: 600;
  margin-top: ${({ theme }) => theme.spacing(0.5)};

  &:focus-visible {
    box-shadow: 0 0 0 ${({ theme }) => theme.spacing(0.5)}
        ${({ theme }) => theme.colors.background.surfaceAlt},
      0 0 0 ${({ theme }) => theme.spacing(1)}
        ${({ theme }) => theme.colors.border.focus};
  }
`;
